export default {
    root: {
        name: "/",
        displayName: "navigationRoutes.home",
    },
    routes: [
        {
            name: "dashboard",
            displayName: "menu.dashboard",
            meta: {
                icon: "fa-home",
            },
        },
        {
            name: "forumindex",
            displayName: "menu.forumpage",
            meta: {
                icon: "fa-comments-o",
            },
            disabled: true,
            // children: [{
            //   name: 'forumindex',
            //   displayName: 'menu.forumindex',
            // }]
        },
        {
            name: "requireManage",
            displayName: "menu.requireManage",
            meta: { icon: "material-icons-source" },
            disabled: true,
            children: [
                {
                    name: "newRequire",
                    displayName: "menu.newRequire",
                },

                {
                    name: "sceneAudit",
                    displayName: "menu.sceneAudit",
                },
                {
                    name: "requireList",
                    displayName: "menu.requireList",
                },
                {
                    name: "courseList",
                    displayName: "menu.courseList",
                },
            ],
        },
        {
            name: "publishManage",
            displayName: "menu.publishManage",
            meta: {
                icon: "material-icons-publish",
            },
            disabled: true,
            children: [
                {
                    name: "publishApply",
                    displayName: "menu.publishApply",
                },
                {
                    name: "dEmpProfile",
                    displayName: "menu.dEmpProfile",
                },
                {
                    name: "myAuditList",
                    displayName: "menu.myAuditList",
                },

                {
                    name: "assetList",
                    displayName: "menu.assetList",
                },
                {
                    name: "licenseList",
                    displayName: "menu.licenseList",
                },
            ],
        },
        {
            name: "processManage",
            displayName: "menu.processManage",
            meta: {
                icon: "material-icons-play_circle_filled",
            },
            disabled: true,
            children: [
                {
                    name: "processTakeList",
                    displayName: "menu.processTakeList",
                },

                {
                    name: "jobList",
                    displayName: "menu.jobList",
                },
                {
                    name: "logList",
                    displayName: "menu.logList",
                },
                {
                    name: "queueList",
                    displayName: "menu.queueList",
                },
                {
                    name: "projectTakeList",
                    displayName: "menu.projectTakeList",
                },
                {
                    name: "jobListPython",
                    displayName: "menu.jobListPython",
                },
                {
                    name: "jobListLocal",
                    displayName: "menu.jobListLocal",
                },
            ],
        },
        {
            name: "statManage",
            displayName: "menu.statManage",
            meta: { icon: "material-icons-storage" },
            disabled: true,
            children: [
                {
                    name: "certificateList",
                    displayName: "menu.certificateList",
                },
                {
                    name: "robotCronList",
                    displayName: "menu.robotCronList",
                },
            ],
        },
        {
            name: "statisticsNew",
            displayName: "menu.statisticsNew",
            meta: {
                icon: "fa-pie-chart",
            },
        },
        {
            name: "statistics",
            displayName: "menu.statistics",
            meta: {
                icon: "fa-bar-chart",
            },
        },
    ],
};
